var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgBt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ff9811",
  d: "M0 85.333h512V426.67H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M512 85.33H0v341.332"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M352.546 181.793v-29.682h-56.891l-4.346 4.346c-15.459 15.459-12.859 33.494-10.96 46.662 1.761 12.216 1.972 16.894-2.57 21.437-4.542 4.542-9.223 4.331-21.437 2.57-13.167-1.898-31.202-4.499-46.661 10.959-15.458 15.459-12.857 33.493-10.957 46.66 1.762 12.213 1.973 16.893-2.568 21.434-4.542 4.54-9.223 4.329-21.434 2.568-4.762-.687-9.686-1.397-14.94-1.455l-.326 29.679c3.289.037 7.049.579 11.029 1.152 4.712.68 10.045 1.45 15.663 1.45 5.821 0 11.945-.83 17.993-3.442v23.747h44.522v-22.261h-22.261v-14.84h14.84v-22.261H229.38c.563-7.201-.426-14.097-1.28-20.009-1.762-12.213-1.973-16.893 2.568-21.434 4.542-4.542 9.222-4.332 21.437-2.57 9.594 1.384 21.774 3.131 33.658-1.999v23.751h44.522v-22.261h-22.261v-14.84h14.84v-22.261h-11.861c.563-7.202-.425-14.097-1.278-20.011-1.23-8.534-1.704-13.39-.329-17.091h43.15z",
  fill: "#f0f0f0"
})));

export default SvgBt;